module.exports = "/_next/static/resources/photo-2-1ec4ffe5611d1f3e8cd4d56e0ef345ec.webp";